var map = {
	"./cn/国际高中/wap.svg": "yC5l",
	"./en/国际高中/wap.svg": "ezba"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "38ZY";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\/国际高中\/wap\.svg$
// module id = 38ZY
// module chunks = 16